/**
 * Normalizes a filename for storage paths (lowercase, safe chars, truncate).
 */
export function normalizeFileName(fileName: string, maxLength = 200): string {
  const trimmed = fileName.trim()
  const lastDot = trimmed.lastIndexOf('.')
  const namePart = lastDot > 0 ? trimmed.substring(0, lastDot) : trimmed
  const ext = lastDot > 0 ? trimmed.substring(lastDot) : ''

  const normalized = namePart
    .toLowerCase()
    .replace(/[()[\]{}]/g, '-')
    .replace(/[#@$%^&*+=|\\/<>?~`!]/g, '-')
    .replace(/[,;:]/g, '-')
    .replace(/_/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .substring(0, Math.max(0, maxLength - ext.length))

  return normalized + ext.toLowerCase()
}
